import api from './api';
import type { LocationOpt } from './contstatusreport.service';
import type { ScacOpt } from './daltile.service';

/**
 * Home Depot Template Mapping — the option bundle for the drawer.
 *
 * The Template picker itself reuses /daltile/template-search (searchTemplates in
 * daltile.service), which is unscoped by customer; Melrose makes the same reuse.
 */
export interface ThdDcOpt { value: string; label: string; }
export interface DispatcherOpt { value: string; label: string; }

export interface ThdOptions {
  dcs: ThdDcOpt[];
  modes: string[];
  scacs: ScacOpt[];
  rails: string[];
  dispatchers: DispatcherOpt[];
  locations: LocationOpt[];
}

export async function getThdOptions(): Promise<ThdOptions> {
  const res = await api.get('/thd/form-options');
  return res.data as ThdOptions;
}
